import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useAtom } from 'jotai';
import intervalAtom from './atoms/intervalAtom';
import DatePicker from '@components/common/DatePicker';
import { withDefaultOptions } from '@components/common/DatePicker/HOC';
import Resiliency from './Resiliency';
import { isResiliencyEnabledSelector } from '@src/store/common/selectors';
import { StyledDatePickerWrapper, StyledTopPanelWrapper, StyledPanel } from './styled';
import FeatureCheck from '@components/common/FeatureCheck';

const DatePickerWithOptions = withDefaultOptions(DatePicker);

const ResiliencyDashboard = () => {
  const isResiliencyEnabled = useSelector(isResiliencyEnabledSelector);
  const [interval, setInterval] = useAtom(intervalAtom);

  const handleDateApply = (dates) => {
    const [from, to] = dates;
    setInterval({
      from: from.format('YYYY-MM-DD HH:mm:ss'),
      to: to.format('YYYY-MM-DD HH:mm:ss'),
    });
  };

  const shortcut = '1d';
  const duration = 7;

  return (
    <>
      <StyledTopPanelWrapper>
        <StyledDatePickerWrapper>
          <DatePickerWithOptions
            defaultValue={[moment(interval.from), moment(interval.to)]}
            defaultShortcut={shortcut}
            onApply={handleDateApply}
            durationAllowed={duration}
            placement="right"
            mode="resiliency"
            granularity={60}
          />
        </StyledDatePickerWrapper>
      </StyledTopPanelWrapper>
      <StyledPanel>
        {isResiliencyEnabled ? (
          <Resiliency interval={interval} />
        ) : (
          <FeatureCheck featureName="Resiliency" />
        )}
      </StyledPanel>
    </>
  );
};

export default ResiliencyDashboard;
